import React, { useContext } from 'react';
import Products from './products';
import { ListerContext } from '../../listerContext';

function ProductsContainer(): React.ReactElement {
  const [{ isBiggerImagesSelected, results, rid }] = useContext(ListerContext);
  return <Products products={results} rid={rid} isBiggerImagesSelected={isBiggerImagesSelected} />;
}

export default ProductsContainer;
